export const environment = {
  production: true,
  api: "https://api-alwayson.recaudia.com/",
  paypal_env: "production",
  paypal_create_payment:
    "https://api-nebula.recaudia.com/v2/paypal/create-payment",
  paypal_onauthorize_payment:
    "https://api-nebula.recaudia.com/v2/paypal/execute-payment",
  accessKey: "upvE2B#_!.0IW3vQZJxC",
};
